<template>
  <div>
  </div>
</template>

<script>
import HelloSign from 'hellosign-embedded';
import axios from "axios";

export default {
  props: ['clientId', 'redirectTo', 'cancelUrl', 'server'],
  name: 'CounterSignFrame',
  data() {
    return {
      client: new HelloSign({ clientId: this.clientId }),
      currentIndex: 0,
      enableTestMode: !!this.server,
      embedUrls: window.embedUrls || [],
    };
  },
  mounted() {
    this.openClient();
  },
  methods: {
    openClient() {
      if (this.currentIndex < this.embedUrls.length) {
        let url = this.embedUrls[this.currentIndex].document_url;
        this.client.open(url, {
          skipDomainVerification: this.enableTestMode,
          testMode: this.enableTestMode
        });
        this.client.on('sign', (data) => {
          this.onSign(data);
        });
        this.client.on('cancel', () => {
          this.onCancel();
        });
        this.client.on('error', (errorData) => {
          this.onError(errorData);
        });
      } else {
        console.error('Error: currentIndex exceeds embedUrls length');
        setTimeout(() => {
          let redirectUrl = this.redirectTo;
          window.location.href = redirectUrl;
        }, 1000);
      }
    },
    onSign(data) {
      this.client.close();
      const investmentId = this.embedUrls[this.currentIndex].investment_id;
      axios.post('counter-signed', {
        investmentId
      }).then((res) => {
        this.currentIndex++;
        this.openClient();
      })
    },
    onCancel() {
      window.location.href = this.cancelUrl
    },
    onError(errorData) {
      console.error('Error occurred during signing:', errorData);
      this.currentIndex++;
      if (this.currentIndex < this.embedUrls.length) {
        const nextUrl = this.embedUrls[this.currentIndex].document_url;
        this.openClient(nextUrl);
      } else {
        let redirectUrl = this.redirectTo;
        window.location.href = redirectUrl;
      }
    },
  }
}
</script>

